import React, { Component, Fragment } from 'react'
import { createComponent } from 'react-fela'
import { array, shape } from 'prop-types'

const FelaSingleColumn = createComponent(
  () => ({
    marginBottom: '128px',
    marginTop: '16px'
  }),
  'section'
)

class SingleColumn extends Component {
  static layoutVariant = 'ISC Hero Page'

  render() {
    const { areas } = this.props
    return (
      <Fragment>
        {areas.hero && <section>{areas.hero}</section>}
        {areas.above && <section>{areas.above}</section>}
        <FelaSingleColumn>{areas.main}</FelaSingleColumn>
      </Fragment>
    )
  }
}

SingleColumn.propTypes = {
  areas: shape({
    hero: array,
    main: array
  })
}

SingleColumn.defaultProps = {
  areas: {
    hero: [],
    main: []
  }
}

export default SingleColumn
